import React from 'react';
import iconImg from '../../../assets/icon-jpeg.svg';
import iconOpen from '../../../assets/icon-open2.svg';
import Button from '../../molecules/Button';
import { NotesTabStyle } from './LeadPreviewSection.styles';

const NotesTab = () => {
  const notesList = [
    {
      id: 1,
      time: '17 June 2023 | 11:45 AM',
      title: 'Aubrey',
      description: "I'm interested. Let's schedule a demo...",
      attachments: [iconImg],
    },
    {
      id: 2,
      time: '21 June 2023 | 09:15 AM',
      title: 'Michael',
      description: 'Please send me the pricing sheet.',
      attachments: [iconImg, iconImg],
    },
    {
      id: 3,
      time: '02 July 2023 | 02:40 PM',
      title: 'Sara',
      description: 'Will get back after internal discussion.',
      attachments: [iconImg, iconImg, iconImg],
    },
  ];

  return (
    <NotesTabStyle>
      <div className="header">
        <strong className="heading">Recent Notes</strong>
        <Button variant="light" newStyle rounded width="155px">
          + Add Notes
        </Button>
      </div>

      {notesList.map(note => (
        <div className="note-block" key={note.id}>
          <div className="text-col">
            <span className="time">{note.time}</span>
            <strong className="title">{note.title}</strong>
            <span className="description">{note.description}</span>
          </div>

          <div className="right-col">
            <div className="img-list">
              {note.attachments.map((img, i) => (
                <div className="img-box" key={i}>
                  <img src={img} width="34" alt="attachment" />
                </div>
              ))}
            </div>

            <button className="btn-open">
              <img src={iconOpen} width="24" alt="open" />
            </button>
          </div>
        </div>
      ))}
    </NotesTabStyle>
  );
};

export default NotesTab;
